<template>
  <b-card no-body v-if="actuals">
    <b-card-header>
      <h3 class="mb-0">{{ economicModel.year }} TRANSACTION STATS</h3>
    </b-card-header>
    <b-row>
      <b-col>
        <b-table responsive small striped hover :items="items" :fields="fields" foot-clone>
          <template #thead-top="data">
            <b-tr>
              <b-th>{{ economicModel.year }} QUARTERLY GOALS</b-th>
              <b-th colspan="4" class="text-center" variant="danger">Jan 01, {{ year }} &ndash; Dec 31, {{ year }}</b-th>
            </b-tr>
          </template>

          <template #cell(quarter)="data">
            <strong>{{ data.item.quarter }}</strong>
          </template>

          <template #cell(closings)="data">
            {{ Math.round(closedUnits * (data.item.seasonality / 100)) }}
          </template>

          <template #cell(volume)="data">
            {{ closedSalesVolume * (data.item.seasonality / 100) | currency }}
          </template>

          <template #cell(gci)="data">
            <span v-if="owner">{{ companyGci * (data.item.seasonality / 100) | currency }}</span>
            <span v-else>{{ grossProfit * (data.item.seasonality / 100) | currency }}</span>
          </template>

          <template #cell(profits)="data">
            {{ economicModel.net_profit_goal * (data.item.seasonality / 100) | currency }}
          </template>

          <template #foot(quarter)="data">
            Totals:
          </template>

          <template #foot(closings)="data">
            {{ closedUnits }}
          </template>

          <template #foot(volume)="data">
            {{ closedSalesVolume | currency }}
          </template>

          <template #foot(gci)="data">
            <span v-if="owner">{{ companyGci | currency }}</span>
            <span v-else>{{ grossProfit | currency }}</span>
          </template>

          <template #foot(profits)="data">
            {{ economicModel.net_profit_goal | currency }}
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table responsive small striped hover :items="actuals.stats" :fields="fields" foot-clone>
          <template #thead-top="data">
            <b-tr>
              <b-th>{{ economicModel.year }} ACTUAL STATS</b-th>
              <b-th colspan="4" class="text-center" variant="danger">Jan 01, {{ year }} &ndash; Dec 31, {{ year }}</b-th>
            </b-tr>
          </template>

          <template #cell(quarter)="data">
            <strong>{{ data.item.quarter }}</strong>
          </template>

          <template #cell(volume)="data">
            {{ data.item.volume | currency }}
          </template>

          <template #cell(gci)="data">
            {{ data.item.gci | currency }}
          </template>

          <template #cell(profits)="data">
            {{ data.item.profits | currency }}
          </template>

          <template #foot(quarter)="data">
            Totals:
          </template>

          <template #foot(closings)="data">
            {{ listingsClosed }}
          </template>

          <template #foot(volume)="data">
            {{ totalVolume | currency }}
          </template>

          <template #foot(gci)="data">
            {{ totalGci | currency }}
          </template>

          <template #foot(profits)="data">
            {{ totalProfits | currency }}
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: {
    actuals: null,
    items: null,
    year: null
  },
  data: function() {
    return {
      fields: [
        {
          key: 'quarter'
        },
        {
          key: 'closings',
          label: 'Pending/Closed',
          variant: 'danger'
        },
        {
          key: 'volume',
          variant: 'danger'
        },
        {
          key: 'gci',
          label: 'GCI',
          variant: 'danger'
        },
        {
          key: 'profits',
          label: 'Profits',
          variant: 'danger'
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      economicModel: 'economicModel/economicModel',
      closedUnits: 'economicModel/closedUnits',
      avgSalePrice: 'economicModel/avgSalePrice',
      grossProfit: 'economicModel/grossProfit',
      companyGci: 'economicModel/companyGci',
      roles: 'roles/roles',
    }),
    listingsClosed() {
      return this.actuals.stats.reduce(function (total, value) {
        return total + Number(value.closings);
      }, 0);
    },
    totalVolume() {
      return this.actuals.stats.reduce(function (total, value) {
        return total + Number(value.volume);
      }, 0);
    },
    totalGci() {
      return this.actuals.stats.reduce(function (total, value) {
        return total + Number(value.gci);
      }, 0);
    },
    totalProfits() {
      return this.actuals.stats.reduce(function (total, value) {
        return total + Number(value.profits);
      }, 0);
    },
    closedSalesVolume() {
      return this.closedUnits * Number(this.avgSalePrice);
    },
    owner() {
      return this.roles.includes('owner');
    },
  }
};
</script>